var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('payment',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"type":_vm.type,"id":"payment","role":"tabpanel","aria-label":"Payment"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e594bf2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Horses/Cart/Payment.vue
// module id = 927
// module chunks = 30